export default (props, vars) => props?.['name'] === 'calendar';
